import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Card, Divider, Grid, CardContent, CardHeader, Avatar, Chip, Typography, IconButton } from '@mui/material';
import { ButtonBasic } from '../../components';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { showModal } from 'react-redux-modal-provider';
import ModalAddVisitaServicio from './ModalAddVisitaServicio';
import ContadorVisitasTkService from '../../services/contadorVisitas-ticket.service';
import FechaFunction from "../../function/FechaFunction";

const ModalContadorVisitasServicio = ({
    show,
    hideModal,
    ticket,
    servicioId,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [itemSaveAll, setItemSaveAll] = useState([]);
    useEffect(() => {
        obtenerContadorVisitasTk()
    }, [])
    const obtenerContadorVisitasTk = async() =>{
        await ContadorVisitasTkService.getAll({ticketId: ticket}).then((tar)=>{
            setItemSaveAll(tar)
        })
    }
    const handleClose = () => hideModal();
    const openModalEquipamiento = () => {
        showModal(ModalAddVisitaServicio,{
            ticketId: ticket,
            servicioId,
            onGuardar2: obtenerContadorVisitasTk
        })
    }
    const openModalEquipamientoUpdate = (itEdit) => {
        showModal(ModalAddVisitaServicio,{
            ticketId: ticket,
            servicioId,
            onGuardar2: obtenerContadorVisitasTk,
            item: itEdit
        })
    }
    const EstadoChip = ({ estado }) => {
        const color = estado === "POSITIVA" ? 'green' : 'red';
        return (
            <Chip
                label={estado}
                sx={{
                backgroundColor: color,
                color: "#fff",
                fontWeight: "bold",
                }}
            />
        );
    };
    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: '#000',fontWeight: 'bold'}} variant='h5'>
                        {`Visitas del servicio #${servicioId}`}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{display: 'flex', justifyContent: 'end'}}>
                            <ButtonBasic
                                textButton='Nueva Visita'
                                onClick={()=>openModalEquipamiento()}
                                isLoading={isLoading}
                                variant='wk'
                                color='nextStep'
                                iconStart={<AddIcon />}
                            />
                        </Grid>
                        {itemSaveAll?.length > 0 && (
                            itemSaveAll.map((visita, index)=>(
                                <Grid item xs={12} sm={6} md={4} key={visita?.id_cvt}>
                                    <Card
                                        sx={{
                                            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                            borderRadius: 2,
                                            border: '1px solid rgba(0, 0, 0, 0.08)',
                                            position: 'relative',
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.12)',
                                                border: '1px solid rgba(3, 100, 255, 0.3)'
                                            }
                                        }}
                                    >
                                        {/* Header compacto */}
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            p: 1.5,
                                            pb: 0
                                        }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Avatar
                                                    src={visita?.autor?.foto_p}
                                                    alt={visita?.autor?.nombre_p}
                                                    sx={{ width: 32, height: 32 }}
                                                />
                                                <Box>
                                                    <Typography
                                                        variant="subtitle2"
                                                        sx={{
                                                            color: '#1a202c',
                                                            fontWeight: 600,
                                                            fontSize: 13,
                                                            lineHeight: 1.2
                                                        }}
                                                    >
                                                        {visita?.autor?.nombre_p || 'Sin autor'}
                                                    </Typography>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            color: '#6b7280',
                                                            fontSize: 11
                                                        }}
                                                    >
                                                        {visita?.autor?.departamento_p || '-'}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <IconButton
                                                size="small"
                                                sx={{
                                                    backgroundColor: 'rgba(3, 100, 255, 0.1)',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(3, 100, 255, 0.2)',
                                                        transform: 'scale(1.1)'
                                                    },
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onClick={()=>openModalEquipamientoUpdate(visita)}
                                            >
                                                <EditIcon sx={{color: '#0364FF', fontSize: 16}} />
                                            </IconButton>
                                        </Box>

                                        {/* Contenido compacto */}
                                        <Box sx={{ p: 1.5, pt: 1 }}>
                                            {/* Fecha y Servicio en una fila */}
                                            <Box sx={{ display: 'flex', gap: 2, mb: 1 }}>
                                                <Box sx={{ flex: 1 }}>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            color: '#4a5568',
                                                            fontWeight: 600,
                                                            fontSize: 10,
                                                            textTransform: 'uppercase'
                                                        }}
                                                    >
                                                        Fecha
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            color: '#2d3748',
                                                            fontSize: 11,
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        {visita?.fechaVisita_cvt ? FechaFunction.format(visita?.fechaVisita_cvt,'dd/MM/yyyy') : '-'}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ flex: 1 }}>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            color: '#4a5568',
                                                            fontWeight: 600,
                                                            fontSize: 10,
                                                            textTransform: 'uppercase'
                                                        }}
                                                    >
                                                        Servicio
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            color: '#2d3748',
                                                            fontSize: 11,
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        #{visita?.servicioId_cvt}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            {/* Estado */}
                                            <Box sx={{ mb: 1 }}>
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        color: '#4a5568',
                                                        fontWeight: 600,
                                                        fontSize: 10,
                                                        textTransform: 'uppercase',
                                                        display: 'block',
                                                        mb: 0.5
                                                    }}
                                                >
                                                    Estado
                                                </Typography>
                                                <Chip
                                                    label={visita?.estadoVisita_cvt}
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: visita?.estadoVisita_cvt === "POSITIVA" ? '#10b981' : '#ef4444',
                                                        color: "#fff",
                                                        fontWeight: 600,
                                                        fontSize: 10,
                                                        height: 22
                                                    }}
                                                />
                                            </Box>
                                            {/* Observaciones */}
                                            <Box>
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        color: '#4a5568',
                                                        fontWeight: 600,
                                                        fontSize: 10,
                                                        textTransform: 'uppercase',
                                                        display: 'block',
                                                        mb: 0.5
                                                    }}
                                                >
                                                    Observaciones
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#2d3748',
                                                        fontSize: 11,
                                                        lineHeight: 1.4,
                                                        backgroundColor: 'rgba(0, 0, 0, 0.03)',
                                                        padding: '6px 8px',
                                                        borderRadius: 1,
                                                        minHeight: 20,
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    {visita?.obs_cvt || 'Sin observaciones'}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))
                        )}
                    </Grid>
                </DialogContent>
                <Divider sx={{background: 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cerrar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalContadorVisitasServicio